<template>
  <HeadingLv3 text="参加病院一覧" class="hospital-title" id="hospital" />
  <p v-if="!hospitals.length">
    参加予定病院は随時決定次第掲載します。
  </p>
  <template v-else>
    <EventDetailHospitalList
      :hospitals="hospitals.slice(0, 6)"
      :isArchived="isArchived"
      :openModal="openModal"
    />
    <button
      v-if="hospitals.length > 6"
      type="button"
      class="eventHospitalsLists_more"
      @click="handleToggle"
      :area-hidden="state.hospitalMoreHidden"
    >
      もっと見る
    </button>
    <div>
      <EventDetailHospitalList
        :hospitals="hospitals.slice(6)"
        :isArchived="isArchived"
        :openModal="openModal"
      />
    </div>
  </template>
</template>

<script lang="ts">
import { PropType, defineComponent, reactive } from 'vue'
import EventDetailHospitalList from '@/components/block/EventDetailHospitalList.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import {
  EventDetailHospitalContent,
  EventDetailHospitalMovie
} from '@/types/EventDetail'

export default defineComponent({
  name: 'EventDetailHospital',
  components: {
    EventDetailHospitalList,
    HeadingLv3
  },
  props: {
    hospitals: {
      type: Array as PropType<EventDetailHospitalContent[]>,
      default: () => [],
      required: true
    },
    isArchived: {
      type: Boolean,
      default: false,
      required: true
    },
    openModal: {
      type: Function as PropType<
        (movies: EventDetailHospitalMovie[], title: string) => void
      >,
      required: true
    }
  },
  setup() {
    const state = reactive({
      hospitalMoreHidden: false
    })

    const handleToggle = (ev: any) => {
      state.hospitalMoreHidden = !state.hospitalMoreHidden

      const target = ev.target

      const next = target.nextElementSibling
      const height = next.firstElementChild.clientHeight + 16

      next.style.height = state.hospitalMoreHidden ? height + 'px' : '0'
    }

    return {
      state,
      handleToggle
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospital-title {
  margin-bottom: 12px;
}

.eventHospitalsLists_more {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  appearance: none;
  width: 100%;
  height: 130px;
  margin-top: -80px;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  border: none;
  overflow: hidden;
  transition: all 0.5s;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.97) 40%,
    rgba(255, 255, 255, 1) 100%
  );

  &::before {
    display: block;
    content: '';
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/icon/expand_off.svg');
    background-size: 20px 20px;
  }

  &[area-hidden='true'] {
    height: 0;
    margin-top: 0;
  }

  & + div {
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
  }
}
</style>
